export const CART_DISCOUNT = {
  MULTIBUY3: 'multibuy3',
  MULTIBUY5: 'multibuy5',
  MULTIBUY10: 'multibuy10',
  DISTINCT_PRODUCTS: 'distinctProducts',
  DISTINCT_PRODUCTS_5_PLUS: 'distinctProducts5plus',
} as const;

export type CartDiscountKey = ValueOf<typeof CART_DISCOUNT>;

export const DISTINCT_PRODUCTS_CART_DISCOUNT_KEYS: string[] = [
  CART_DISCOUNT.DISTINCT_PRODUCTS,
  CART_DISCOUNT.DISTINCT_PRODUCTS_5_PLUS,
];

/**
 * Cart discounts the cart needs to know about *before* commercetools applies
 * them, so they can be offered under "unlock more savings". They are fetched in
 * one request by their keys - adding a key here is enough to have it loaded,
 * it then only needs a composable that reads its configuration.
 */
export const UNLOCKABLE_CART_DISCOUNT_KEYS: CartDiscountKey[] = [
  CART_DISCOUNT.DISTINCT_PRODUCTS,
];
